import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { AiFillEdit } from "react-icons/ai";
import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { getFileIcon } from "utils/utils";
import { getOriginalFileName } from "utils/utils";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ViewPriceListModal({ open, handleClose, data, onEdit }) {
  if (!data) return null;

  return (
    <BootstrapDialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        <div className="flex items-center justify-between">
          <span className="text-xl font-semibold">Price List Details</span>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <div className="flex flex-col gap-6">
          {/* Module */}
          <div className="flex flex-col">
            <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
              Module
            </label>
            <div className="text-app-text text-base py-2 px-3 bg-app-surface-muted rounded border border-app-border">
              {data?.module || "—"}
            </div>
          </div>

          {/* Service Charges Row */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="flex flex-col">
              <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
                Minimum Service Charge
              </label>
              <div className="text-app-text text-base py-2 px-3 bg-app-surface-muted rounded border border-app-border">
                {data?.minimumServiceCharge || "—"}
              </div>
            </div>
            <div className="flex flex-col">
              <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
                Maximum Service Charge
              </label>
              <div className="text-app-text text-base py-2 px-3 bg-app-surface-muted rounded border border-app-border">
                {data?.maximumServiceCharge || "—"}
              </div>
            </div>
            <div className="flex flex-col">
              <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
                Normal Service Charge
              </label>
              <div className="text-app-text text-base py-2 px-3 bg-app-surface-muted rounded border border-app-border">
                {data?.normalServiceCharge || "—"}
              </div>
            </div>
          </div>

          {/* Government Fees */}
          <div className="flex flex-col">
            <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
              Government Fees
            </label>
            <div className="text-app-text text-base py-2 px-3 bg-app-surface-muted rounded border border-app-border">
              {data?.governmentFees || "—"}
            </div>
          </div>

          {/* Requirements */}
          <div className="flex flex-col">
            <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
              Checklist
            </label>
            <div className="text-app-text text-base py-3 px-4 bg-app-surface-muted rounded border border-app-border min-h-[100px]">
              {data?.requirements ? (
                <div
                  dangerouslySetInnerHTML={{ __html: data.requirements }}
                  className="prose prose-sm max-w-none"
                />
              ) : (
                <span className="text-app-text-muted">—</span>
              )}
            </div>
          </div>

          {/* Notes */}
          {data?.notes && (
            <div className="flex flex-col">
              <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
                Notes
              </label>
              <div className="text-app-text text-base py-2 px-3 bg-app-surface-muted rounded border border-app-border whitespace-pre-wrap">
                {data.notes}
              </div>
            </div>
          )}
          {data?.key4?.length > 0 && (
            <div className="flex flex-col">
              <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
                Attachments
              </label>
              <div className="flex flex-wrap flex-col gap-2">
                {data?.key4?.map((item, index) => (
                  <Tooltip key={item || index} title={item} arrow>
                    <div className="flex items-center gap-2">
                      <a
                        href={item}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center w-12 h-12 rounded border border-app-border hover:bg-app-surface-hover transition-colors"
                      >
                        {getFileIcon(item)}
                      </a>{" "}
                      <span className="text-sm text-app-text pl-2">
                        {item && getOriginalFileName(item)}
                      </span>
                      <Tooltip title="Download">
                        <Link
                          to={item}
                          download
                          target="_blank"
                          className="text-app-text-secondary hover:text-primary"
                        >
                          <FileDownloadIcon className="text-sm" />
                        </Link>
                      </Tooltip>
                    </div>
                  </Tooltip>
                ))}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions className="py-2 px-4">
        <Button onClick={handleClose} variant="outlined">
          Close
        </Button>
        {onEdit && (
          <Button onClick={onEdit} variant="contained" startIcon={<AiFillEdit />}>
            Edit
          </Button>
        )}
      </DialogActions>
    </BootstrapDialog>
  );
}
